export default "__VITE_ASSET__ClRR$E3i__"